import React from "react";
import { motion, AnimationDefinition } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import { bonusTextVariant } from "../utils";

interface MegaShareBonusTextProps extends PropsWithClassName {
  zIndex: number;
  onAnimationComplete: (definition: AnimationDefinition) => void;
}

const MegaShareBonusText = ({
  className,
  zIndex,
  onAnimationComplete,
}: MegaShareBonusTextProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={cn(
        "absolute top-[25px] w-fit",
        className
      )}
      style={{ zIndex }}
      variants={bonusTextVariant}
      onAnimationComplete={onAnimationComplete}
    >
      <div className="relative w-fit">
        <div
          className={cn(
            "w-fit",
            "rounded-[5px]",
            "bg-[linear-gradient(180deg,#FDC135_21.54%,#EFDD75_86.12%)]",
            "pt-[5px] pb-1 px-[6px]",
            "flex items-center justify-center",
            "text-[12px] font-bold uppercase whitespace-nowrap",
            "relative z-10"
          )}
          style={{
            fontFamily: "Noto Sans Thai",
            color: "var(--Components-DownloadBar-Bg, #0C0629)",
          }}
        >
          {t("you got a gift")}
        </div>

        <img
          src="/images/mega-share/triangle-down.png"
          alt=""
          className={cn(
            "absolute left-1/2 -translate-x-1/2",
            "bottom-[-7px]",
            "w-[18px] h-[10px]"
          )}
        />
      </div>
    </motion.div>
  );
};

export default MegaShareBonusText;